import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Pipe({
  name: 'translateByCustomerType',
})
export class TranslateByCustomerTypePipe extends TranslatePipe implements PipeTransform {
  transform(key: string, clientType: string, vars?: Object): string {
    const keyByClientType = key + '.' + clientType.toLowerCase();
    let value = super.transform(keyByClientType, vars);
    value = value === keyByClientType ? super.transform(key, vars) : value;
    return value === key ? super.transform(`${key}.default`, vars) : value;
  }
}
